"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preparingTransformersModule = void 0;
const InversifyContainerFacade_1 = require("../../InversifyContainerFacade");
const inversify_1 = require("inversify");
const ServiceIdentifiers_1 = require("../../ServiceIdentifiers");
const NodeTransformer_1 = require("../../../enums/node-transformers/NodeTransformer");
const ObfuscatingGuard_1 = require("../../../enums/node-transformers/preparing-transformers/obfuscating-guards/ObfuscatingGuard");
const BlackListObfuscatingGuard_1 = require("../../../node-transformers/preparing-transformers/obfuscating-guards/BlackListObfuscatingGuard");
const ConditionalCommentObfuscatingGuard_1 = require("../../../node-transformers/preparing-transformers/obfuscating-guards/ConditionalCommentObfuscatingGuard");
const CustomCodeHelpersTransformer_1 = require("../../../node-transformers/preparing-transformers/CustomCodeHelpersTransformer");
const EvalCallExpressionTransformer_1 = require("../../../node-transformers/preparing-transformers/EvalCallExpressionTransformer");
const ForceTransformStringObfuscatingGuard_1 = require("../../../node-transformers/preparing-transformers/obfuscating-guards/ForceTransformStringObfuscatingGuard");
const IgnoredImportObfuscatingGuard_1 = require("../../../node-transformers/preparing-transformers/obfuscating-guards/IgnoredImportObfuscatingGuard");
const ImportMetaObfuscationGuard_1 = require("../../../node-transformers/preparing-transformers/obfuscating-guards/ImportMetaObfuscationGuard");
const ProcessEnvObfuscationGuard_1 = require("../../../node-transformers/preparing-transformers/obfuscating-guards/ProcessEnvObfuscationGuard");
const MetadataTransformer_1 = require("../../../node-transformers/preparing-transformers/MetadataTransformer");
const ObfuscatingGuardsTransformer_1 = require("../../../node-transformers/preparing-transformers/ObfuscatingGuardsTransformer");
const ParentificationTransformer_1 = require("../../../node-transformers/preparing-transformers/ParentificationTransformer");
const ReservedStringObfuscatingGuard_1 = require("../../../node-transformers/preparing-transformers/obfuscating-guards/ReservedStringObfuscatingGuard");
const VariablePreserveTransformer_1 = require("../../../node-transformers/preparing-transformers/VariablePreserveTransformer");
exports.preparingTransformersModule = new inversify_1.ContainerModule((options) => {
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(CustomCodeHelpersTransformer_1.CustomCodeHelpersTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.CustomCodeHelpersTransformer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(EvalCallExpressionTransformer_1.EvalCallExpressionTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.EvalCallExpressionTransformer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(MetadataTransformer_1.MetadataTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.MetadataTransformer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(ObfuscatingGuardsTransformer_1.ObfuscatingGuardsTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.ObfuscatingGuardsTransformer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(ParentificationTransformer_1.ParentificationTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.ParentificationTransformer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeTransformer)
        .to(VariablePreserveTransformer_1.VariablePreserveTransformer)
        .whenNamed(NodeTransformer_1.NodeTransformer.VariablePreserveTransformer);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeGuard)
        .to(BlackListObfuscatingGuard_1.BlackListObfuscatingGuard)
        .inSingletonScope()
        .whenNamed(ObfuscatingGuard_1.ObfuscatingGuard.BlackListObfuscatingGuard);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeGuard)
        .to(ConditionalCommentObfuscatingGuard_1.ConditionalCommentObfuscatingGuard)
        .inSingletonScope()
        .whenNamed(ObfuscatingGuard_1.ObfuscatingGuard.ConditionalCommentObfuscatingGuard);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeGuard)
        .to(ForceTransformStringObfuscatingGuard_1.ForceTransformStringObfuscatingGuard)
        .inSingletonScope()
        .whenNamed(ObfuscatingGuard_1.ObfuscatingGuard.ForceTransformStringObfuscatingGuard);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeGuard)
        .to(IgnoredImportObfuscatingGuard_1.IgnoredImportObfuscatingGuard)
        .inSingletonScope()
        .whenNamed(ObfuscatingGuard_1.ObfuscatingGuard.IgnoredImportObfuscatingGuard);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeGuard)
        .to(ImportMetaObfuscationGuard_1.ImportMetaObfuscationGuard)
        .inSingletonScope()
        .whenNamed(ObfuscatingGuard_1.ObfuscatingGuard.ImportMetaObfuscationGuard);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeGuard)
        .to(ProcessEnvObfuscationGuard_1.ProcessEnvObfuscationGuard)
        .inSingletonScope()
        .whenNamed(ObfuscatingGuard_1.ObfuscatingGuard.ProcessEnvObfuscationGuard);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.INodeGuard)
        .to(ReservedStringObfuscatingGuard_1.ReservedStringObfuscatingGuard)
        .inSingletonScope()
        .whenNamed(ObfuscatingGuard_1.ObfuscatingGuard.ReservedStringObfuscatingGuard);
    options
        .bind(ServiceIdentifiers_1.ServiceIdentifiers.Factory__INodeGuard)
        .toFactory(InversifyContainerFacade_1.InversifyContainerFacade.getCacheFactory(ServiceIdentifiers_1.ServiceIdentifiers.INodeGuard));
});
